<!--<div class="container">-->
  <div>
    <dx-data-grid [dataSource]="advisors"
                  [columns]="gridColumns"
                  [paging]="{ pageSize: 15 }"
                  [rowAlternationEnabled]="true"
                  [showBorders]="true"
                  [columnAutoWidth]="true"
                  [allowColumnReordering]="true"
                  [allowColumnResizing]="true"
                  [columnResizingMode]="'widget'"
                  [filterRow]="{ visible: true }"
                  [searchPanel]="{ visible: true, width: 240, placeholder: 'Search...' }"
                  width="100%"
                  [wordWrapEnabled]="true">
      <!--
        <div *dxTemplate="let cell of 'colFullName'">
          <a class="text-info"
             [routerLink]="['/update-advisor', cell.data.id]"
             title="Click to view details">{{ cell.data.fullName }}</a>
        </div>
      -->
      <!-- Actions Column Template -->
      <div *dxTemplate="let cell of 'btnActions'">
        <button type="button"
                class="btn btn-xs btn-primary2"
                title="Impersonate advisor"
                (click)="impersonateAdvisor(cell.data)"
                [disabled]="!(okToImpersonateAdvisor(cell.data))">
          <i class="fa fa-user-secret"></i>&nbsp;Impersonate
        </button>

        <!--
        <a *ngIf="isServicerAdmin() && cell.data.systemLogin?.loginStatus === 0"
           href="#"
           [ngClass]="{'disabled-link': isDisabled}"
           class="btn btn-xs btn-default"
           title="Activate system login for {{ cell.data.fullName }}"
           (click)="enableSL(cell.data)">
          <i class="fa fa-globe"></i>&nbsp;Activate
        </a>

        <a *ngIf="isServicerAdmin() && (cell.data.systemLogin?.loginStatus === 4 || cell.data.systemLogin?.loginStatus === 3)"
           href="#"
           class="btn btn-xs btn-default"
           title="Reactivate system login for {{ cell.data.fullName }}"
           (click)="reactivateSL(cell.data)">
          <i class="fa fa-refresh"></i>&nbsp;Reactivate
        </a>

        <a *ngIf="isServicerAdmin() && cell.data.systemLogin?.loginStatus !== 3"
           href="#"
           [ngClass]="{'disabled-link': isDisabled}"
           class="btn btn-xs btn-default"
           title="Disable system login for {{ cell.data.fullName }}"
           (click)="disableSL(cell.data)">
          <i class="fa fa-stop-circle"></i>&nbsp;Cancel
        </a>

        <a *ngIf="isServicerAdmin() && cell.data.systemLogin?.loginStatus === 1"
           href="#"
           class="btn btn-xs btn-default"
           title="Lock system login for {{ cell.data.fullName }}"
           (click)="lockSL(cell.data)">
          <i class="fa fa-lock"></i>&nbsp;Lock
        </a>

        <a *ngIf="isServicerAdmin() && cell.data.systemLogin?.loginStatus === 2"
           href="#"
           class="btn btn-xs btn-default"
           title="Unlock system login for {{ cell.data.fullName }}"
           (click)="unlockSL(cell.data)">
          <i class="fa fa-unlock"></i>&nbsp;Unlock
        </a>
        -->

      </div>
    </dx-data-grid>
  </div>
